// Opaque keys to ensure that you can't fake arbitrary compartment Ids into tokens.
// This file is not publicly exposed.

export const API_KEY: unique symbol = Symbol('apiKey');
export const ID: unique symbol = Symbol('id');
export const TYPE: unique symbol = Symbol('type');
export const V2_COMPARTMENT_LTM: unique symbol = Symbol('ltm');
export const V2_COMPARTMENT_SKIP_LTM: unique symbol = Symbol('skipLtm');
export const LIVE_MODE: unique symbol = Symbol('liveMode');

export const ORG_ACTIVE_CONTEXT_REGEXP =
  /(org_(?:test_)?[a-zA-Z0-9]+|org_[a-zA-Z0-9]+)/;
export const PLAYGROUND_ACTIVE_CONTEXT_REGEXP =
  /(play_(?:test_)?[a-zA-Z0-9]+|play_[a-zA-Z0-9]+)/;
export const ACCOUNT_ACTIVE_CONTEXT_REGEXP =
  /(acct_[a-zA-Z0-9]+|user_[a-zA-Z0-9]+|[a-zA-Z0-9]{32}|wksp_(?:test_)?[a-zA-Z0-9]+|)/;
export const NON_WORKSPACE_ID_PREFIXES = ['org_', 'play_', 'shrd_'];
